import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/base/services/base.service';
import { ProjetoTramitacao } from '../models/projeto-tramitacao.model';

@Injectable()
export class ProjetoTramitacaoService extends BaseService<ProjetoTramitacao> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/pre-projeto/projeto-tramitacao';
  }

  public updateDocumento(obj, id: number): Observable<any> {
    return this.http.post<ProjetoTramitacao>(this.baseUrl + '/' + id, obj);
  }

  public createDocumento(obj): Observable<ProjetoTramitacao> {
    return this.http.post<ProjetoTramitacao>(this.baseUrl, obj);
  }

  public download(id: number): Observable<HttpResponse<Blob>> {
    return this.http.get(this.baseUrl + "/download/" + id, {
      headers: this.headers,
      responseType: 'blob',
      observe: 'response'
    })
  }

  extractFilename(contentDispositionHeader: string): string | null {
    const matches = contentDispositionHeader.match(/filename\*=(?:UTF-8['']?)?([^;\r\n]*)/i);
    if (matches && matches.length > 1) {
      let encodedFilename = matches[1].trim();
      return decodeURIComponent(encodedFilename);
    }
    return null;
  }

}
